import React from 'react'
import styled from 'styled-components'

const Text = styled.h6`
  margin: 0;
  font-size: 16px;
  font-family: 'Roboto-bold';
  @media screen and (max-width: 1366px) {
    font-size: 14px;
  }
`

const H6 = ({ className, children }) => (
  <Text className={className}>{children}</Text>
)

export default H6
